import React from 'react'

import { Text } from '@primer/components'
import Editor from 'react-simple-code-editor';
import hljs from 'highlight.js'

import Code from '../../components/Code'
import { CATEGORY_TESTS as category, IMPACT_LOW as impact } from '../../constants'


export const exampleTitle = 'tests.py'

export const exampleBefore = (
`class TestFeature(unittest.TestCase):
    def test_feature(self):
        self.assertEquals(int('1'), 1)`
)

export const exampleAfter = (
`class TestFeature(unittest.TestCase):
    def test_feature(self):
        self.assertEqual(int('1'), 1)`
)

export const code = 'NoAssertEquals'

export const title = 'Use assertEqual instead of deprecated assertEquals'

export const wordCode = 'avoid-assert-equals'

export const furtherReading = [
  {
    href: 'https://docs.python.org/3/library/unittest.html#deprecated-aliases',
    text: 'Python documentation on deprecated TestCase aliases'
  }
]

export function Summary(props) {
  return (
    <Text as={'p'} className={props.className}>
      Use <Code>self.assertEqual</Code> in tests instead of <Code>self.assertEquals</Code>.
    </Text>
  )
}

export const explanation = (
  <>
    <Text as="p">For historical reasons, some <Code>TestCase</Code> methods had one or more aliases that are now deprecated.</Text>
    <Text as="p">Use the standardised <Code>assertEqual</Code> so the code is simpler, easier to read, and more future-proof (because an implication of deprecation is it will eventually be removed).</Text>
  </>
)

export {category, impact}
